import {
  firebaseAction
} from 'vuexfire/dist/vuexfire.esm'
import {
  API
} from '../../utils/api'

export default {
  //
  // firebaseAction
  //
  bindWidget: firebaseAction(({
    bindFirebaseRef
  }, {
    ref,
    widgetId
  }) => {
    bindFirebaseRef('widget', ref.child('widgets/' + widgetId),{
      readyCallback: ()=>{ API.$emit('widgetConnected') }
    })
    //Add notify install
  }),
  bindConnected: firebaseAction(({
    bindFirebaseRef
  }, {
    ref
  }) => {
    [
      'teams',
      'agents',
      'roundrobin',
      'integrations'
    ].forEach((item) => {
      bindFirebaseRef(item, ref.child(item))
    })
  }),
  bindSession: firebaseAction(({
    bindFirebaseRef
  }, {
    ref
  }) => {
    bindFirebaseRef('session', ref,{
      readyCallback: ()=>{ API.$emit('sessionConnected') }
    })
  }),
  bindHistory: firebaseAction(({
    bindFirebaseRef, dispatch
  }, {
    ref
  }) => {
    bindFirebaseRef('history', ref, {
      readyCallback: ()=>{ dispatch('postPageHistory') }
    })
  }),
  bindMessages: firebaseAction(({
    bindFirebaseRef, dispatch
  }, {
    ref
  }) => {
    bindFirebaseRef('messages', ref,{
      readyCallback: ()=>{
        dispatch('postPageEvent')
        API.$emit('messagesBound')
      }
    })
  }),
  bindVisitor: firebaseAction(({
    bindFirebaseRef, dispatch
  }, {
    ref
  }) => {
    bindFirebaseRef('visitor', ref,{
      readyCallback: ()=>{ API.$emit('visitorConnected') }
    })
  })
}
